const STATUSES = Object.freeze({
    INACTIVE: 'Inactive',
    ACTIVE: 'Active'
  });

const STATUS_ARRAY = [
  STATUSES.ACTIVE,
  STATUSES.INACTIVE,
];


module.exports = {
  STATUSES,
  STATUS_ARRAY
}